import { createCssVariables } from "@prophero-ds/web-tokens";

import "@prophero-ds/react-components/styles.css";

let tokensInjected = false;

export function ensureDesignSystemTokens(): void {
  if (tokensInjected) return;
  const styleTag = document.createElement("style");
  styleTag.setAttribute("data-source", "design-system-tokens");
  const cssVariables: string = createCssVariables();
  styleTag.textContent = cssVariables;
  document.head.append(styleTag);
  tokensInjected = true;
}
